<template>
  <question-group headline="Write">
    <write-response :model="blast.write" :respondable="blast.isOpen" />
    <review-display :blast="blast" />
  </question-group>
</template>

<script>

  import sidebar from "./sidebar.js"
  import ReviewDisplay from "../ReviewDisplay"

  export default {
    name: 'write',
    mixins: [sidebar],
    components: { ReviewDisplay }
  }
</script>



// WEBPACK FOOTER //
// src/components/BlastStudent/sidebar/write.vue